// @ts-check
// WHAT IS WORTH FINDING BY NAME IN THIS APPLICATION (plan-6 §6b.1).
//
// The palette searches this client's screens for free — they come from
// config/navigation.js, so a screen cannot be reachable by search and absent
// from the rail. This file adds RECORDS to that, and it is the application's to
// write because only the application knows which of its records a person hunts
// for by typing a name.
//
// Each source is loaded once, on the palette's first open, never on mount; a
// source that throws is simply absent, because one dead endpoint must not take
// the search box down with it.
//
//   {
//     key: 'employees',                       // needs search.group.employees
//     load: () => listEmployees({}),          // array, or { items: [] }
//     match: (row, q) => row.fullName.toLowerCase().includes(q),
//     toItem: (row) => ({ id: `employee:${row.id}`, label: row.fullName,
//                         hint: row.jobTitle, to: `/employees/${row.id}` }),
//   }
//
// TWO SOURCES (PLATFORM-UX-AUDIT §3.3): the people register and the cohort
// register, the two things a coordinator hunts for by typing a name or a
// code. Each is one page of up to 500 rows, loaded on the palette's first
// open — the same cap the pickers already live under; a register past it
// still answers its first 500 and the screen's own search answers the rest.
import { listPeople } from '../services/people/peopleService';
import { listCohorts } from '../services/cohorts/cohortsService';

const has = (value, q) => (value ?? '').toLowerCase().includes(q);

export const paletteSources = [
    {
        key: 'people',
        load: () => listPeople({ size: 500 }, {}),
        match: (person, q) => has(person.fullName, q) || has(person.email, q),
        toItem: (person) => ({
            id: `person:${person.id}`,
            label: person.fullName,
            hint: person.email,
            to: `/people/${person.id}`,
        }),
    },
    {
        key: 'cohorts',
        load: () => listCohorts({ size: 500 }, {}),
        match: (cohort, q) => has(cohort.code, q) || has(cohort.programName, q),
        toItem: (cohort) => ({
            id: `cohort:${cohort.id}`,
            label: cohort.code,
            hint: cohort.programName,
            to: `/cohorts/${cohort.id}`,
        }),
    },
];
